export const BASE_COLUMNS = [
  { key: 'discordSelect', label: '★' },
  { key: 'position', label: '#' },
  { key: 'user', label: 'User' },
  { key: 'teamName', label: 'Team Name' },
  { key: 'cup', label: 'Cup', sortKey: 'cup' },
]

export const MY_CUP_COLUMNS = [
  { key: 'cupSeed', label: 'Cup seed' },
  { key: 'inheritedCupSeed', label: 'Inherited seed' },
  { key: 'remainingCupSeed', label: 'Seed among remaining' },
]

export const TEAM_MODE_COLUMNS = [
  {
    key: 'coach',
    label: 'Coach',
    searchButtons: [
      { key: 'coachSkill', label: 'Skill' },
      { key: 'coachLeadership', label: 'Leadership' },
    ],
  },
  { key: 'type', label: 'Type', sortKey: 'coachTypeOrder' },
  { key: 'youth', label: 'Youth', sortKey: 'youthTeamMode' },
  { key: 'fanClub', label: 'FanClub', sortKey: 'fanClub', searchKey: 'fanClub', searchLabel: 'Fans' },
  { key: 'arenaCapacity', label: 'Arena', sortKey: 'arenaCapacity', searchKey: 'arenaCapacity' },
  { key: 'hatstats', label: 'Hat stats', sortKey: 'hatstats', searchKey: 'hatstats' },
  { key: 'remainingCupSeed', label: 'Seed among remaining', sortKey: 'remainingCupSeed' },
  { key: 'rank', label: 'Rank', sortKey: 'rank', searchKey: 'rank' },
  { key: 'points', label: 'Pts', sortKey: 'points', searchKey: 'points' },
  { key: 'goalDiff', label: '+/-', sortKey: 'goalDiff' },
  { key: 'leaguePosition', label: 'Pos', sortKey: 'leaguePosition', searchKey: 'leaguePosition' },
  { key: 'series', label: 'Series', sortKey: 'series' },
]

export const PLAYERS_MODE_COLUMNS = [
  { key: 'youth', label: 'Youth', sortKey: 'youthTopSalary', searchKey: 'youthTopSalary' },
  { key: 'salaryTotal', label: 'Salary Sum', sortKey: 'salaryTotal', searchKey: 'salaryTotal' },
  { key: 'tsiTotal', label: 'TSI Sum', sortKey: 'tsiTotal', searchKey: 'tsiTotal' },
  { key: 'avgAge', label: 'Avg Age', sortKey: 'avgAge', searchKey: 'avgAge' },
  { key: 'avgExperience', label: 'Avg Exp', sortKey: 'avgExperience', searchKey: 'avgExperience' },
  { key: 'avgStamina', label: 'Avg Stamina', sortKey: 'avgStamina', searchKey: 'avgStamina' },
  { key: 'avgForm', label: 'Avg Form', sortKey: 'avgForm', searchKey: 'avgForm' },
  { key: 'specialtyCount', label: 'Spec', sortKey: 'specialtyCount', searchKey: 'specialtyCount', searchLabel: 'Specialties' },
]

export const MAX_YOUTH_VALUE = 'max-youth'
export const SPECIALTY_PLUS_VALUE = 'specialty-plus'
export const SPECIALTY_MINUS_VALUE = 'specialty-minus'
export const DISCORD_NO_VALUE = 'discord-no'
export const FAVORITE_VALUE = 'favorite'
export const MY_CUP_VALUE = 'my-cup'
export const AVERAGE_TEAM_VALUE = 'average-team'
export const BOT_SERIES_VALUE = 'bot-series'
export const BOT_SERIES_LEVEL_PREFIX = 'bot-series-'
export const SAVED_FILTER_VALUE_PREFIX = 'saved-filter-'
export const SERIES_VALUE_PREFIX = 'series-'
export const PLAYER_STATS_SCOPE_ALL = 'all'
export const PLAYER_STATS_SCOPE_TOP11 = 'top11'
export const TABLE_MODE_TEAM = 'team'
export const TABLE_MODE_PLAYERS = 'players'
export const URL_TOKEN_MAX_YOUTH = 'MAXYOUTH'
export const URL_TOKEN_DISCORD_NO = 'DISCORD_NO!'
export const URL_TOKEN_SPECIALTY_PLUS = 'SPECIALTY+'
export const URL_TOKEN_SPECIALTY_MINUS = 'SPECIALTY-'
export const URL_TOKEN_FAVORITE = 'FAVORITE'
export const URL_TOKEN_MY_CUP = 'mycup'
export const URL_TOKEN_BOT_SERIES = 'BOTSERIES'
